import { Control, Controller } from "react-hook-form";
import FilledInput, { FilledInputProps } from "@material-ui/core/FilledInput";
import InputAdornment from "@material-ui/core/InputAdornment";
import React, { FC, ReactNode, useState } from "react";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { ButtonBase } from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";

const useStyles = makeStyles(theme =>
    createStyles({
        filledInput: {
            width: "100%",
            height: "46px",
            marginTop: theme.spacing(2)
        }
    })
);

interface ControlledFilledInputIndexProps extends FilledInputProps {
    control: any;
    errors: boolean;
    placeholder: string;
    name: string;
    required?: boolean;
    icon: ReactNode;
}

export const ControlledFilledInputIndex: FC<ControlledFilledInputIndexProps> = ({ control, errors, placeholder, name, required, icon, ...props }) => {
    const classes = useStyles();
    const [showPassword, setShowPassword] = useState(false);

    return (
        <Controller
            control={control}
            name={name}
            render={({ field }) => (
                <FilledInput
                    {...field}
                    {...props}
                    placeholder={placeholder}
                    autoComplete="off"
                    className={classes.filledInput}
                    required={required}
                    type={showPassword ? "text" : name}
                    error={errors}
                    startAdornment={
                        <InputAdornment style={{ background: "transparent" }} position={"start"}>
                            {icon}
                        </InputAdornment>
                    }
                    endAdornment={
                        name === "password" && (
                            <InputAdornment position="end" style={{ background: "transparent" }}>
                                <ButtonBase onClick={() => setShowPassword(!showPassword)}>{showPassword ? <Visibility /> : <VisibilityOff />}</ButtonBase>
                            </InputAdornment>
                        )
                    }
                />
            )}
        />
    );
};
